/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetWarehousesDocument = gql`
    query GetWarehouses($page: Int!, $itemsPerPage: Int!, $currentBranchId: Int!, $companyId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branchesPaginated(id: $currentBranchId) {
        branches {
          storagesPaginated(page: $page, itemsPerPage: $itemsPerPage) {
            storages {
              id
              name
              description
              deleted
              type {
                id
                name
              }
              storageProductRelations {
                id
                quantity
              }
              default
            }
            totalCount
            currentPage
            itemsPerPage
            pageCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetWarehousesQuery__
 *
 * To run a query within a React component, call `useGetWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarehousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarehousesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      currentBranchId: // value for 'currentBranchId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetWarehousesQuery(baseOptions: Apollo.QueryHookOptions<GetWarehousesQuery, GetWarehousesQueryVariables> & ({ variables: GetWarehousesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarehousesQuery, GetWarehousesQueryVariables>(GetWarehousesDocument, options);
      }
export function useGetWarehousesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarehousesQuery, GetWarehousesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarehousesQuery, GetWarehousesQueryVariables>(GetWarehousesDocument, options);
        }
export function useGetWarehousesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarehousesQuery, GetWarehousesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWarehousesQuery, GetWarehousesQueryVariables>(GetWarehousesDocument, options);
        }
export type GetWarehousesQueryHookResult = ReturnType<typeof useGetWarehousesQuery>;
export type GetWarehousesLazyQueryHookResult = ReturnType<typeof useGetWarehousesLazyQuery>;
export type GetWarehousesSuspenseQueryHookResult = ReturnType<typeof useGetWarehousesSuspenseQuery>;
export type GetWarehousesQueryResult = Apollo.QueryResult<GetWarehousesQuery, GetWarehousesQueryVariables>;
export const GetStorageTypesDocument = gql`
    query GetStorageTypes {
  relations {
    storageTypes {
      id
      name
    }
  }
}
    `;

/**
 * __useGetStorageTypesQuery__
 *
 * To run a query within a React component, call `useGetStorageTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStorageTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStorageTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStorageTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetStorageTypesQuery, GetStorageTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStorageTypesQuery, GetStorageTypesQueryVariables>(GetStorageTypesDocument, options);
      }
export function useGetStorageTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStorageTypesQuery, GetStorageTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStorageTypesQuery, GetStorageTypesQueryVariables>(GetStorageTypesDocument, options);
        }
export function useGetStorageTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStorageTypesQuery, GetStorageTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStorageTypesQuery, GetStorageTypesQueryVariables>(GetStorageTypesDocument, options);
        }
export type GetStorageTypesQueryHookResult = ReturnType<typeof useGetStorageTypesQuery>;
export type GetStorageTypesLazyQueryHookResult = ReturnType<typeof useGetStorageTypesLazyQuery>;
export type GetStorageTypesSuspenseQueryHookResult = ReturnType<typeof useGetStorageTypesSuspenseQuery>;
export type GetStorageTypesQueryResult = Apollo.QueryResult<GetStorageTypesQuery, GetStorageTypesQueryVariables>;
export const CreateStorageDocument = gql`
    mutation CreateStorage($branchId: Int!, $input: StorageInput!) {
  createStorage(branchId: $branchId, input: $input) {
    id
    name
  }
}
    `;
export type CreateStorageMutationFn = Apollo.MutationFunction<CreateStorageMutation, CreateStorageMutationVariables>;

/**
 * __useCreateStorageMutation__
 *
 * To run a mutation, you first call `useCreateStorageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStorageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStorageMutation, { data, loading, error }] = useCreateStorageMutation({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStorageMutation(baseOptions?: Apollo.MutationHookOptions<CreateStorageMutation, CreateStorageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStorageMutation, CreateStorageMutationVariables>(CreateStorageDocument, options);
      }
export type CreateStorageMutationHookResult = ReturnType<typeof useCreateStorageMutation>;
export type CreateStorageMutationResult = Apollo.MutationResult<CreateStorageMutation>;
export type CreateStorageMutationOptions = Apollo.BaseMutationOptions<CreateStorageMutation, CreateStorageMutationVariables>;
export const UpdateStorageDocument = gql`
    mutation UpdateStorage($storageId: Int!, $input: StorageInput!, $branchId: Int!) {
  updateStorage(storageId: $storageId, input: $input, branchId: $branchId) {
    id
    name
  }
}
    `;
export type UpdateStorageMutationFn = Apollo.MutationFunction<UpdateStorageMutation, UpdateStorageMutationVariables>;

/**
 * __useUpdateStorageMutation__
 *
 * To run a mutation, you first call `useUpdateStorageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStorageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStorageMutation, { data, loading, error }] = useUpdateStorageMutation({
 *   variables: {
 *      storageId: // value for 'storageId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useUpdateStorageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStorageMutation, UpdateStorageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStorageMutation, UpdateStorageMutationVariables>(UpdateStorageDocument, options);
      }
export type UpdateStorageMutationHookResult = ReturnType<typeof useUpdateStorageMutation>;
export type UpdateStorageMutationResult = Apollo.MutationResult<UpdateStorageMutation>;
export type UpdateStorageMutationOptions = Apollo.BaseMutationOptions<UpdateStorageMutation, UpdateStorageMutationVariables>;
export const DeleteStorageDocument = gql`
    mutation DeleteStorage($storageId: Int!, $branchId: Int!) {
  deleteStorage(storageId: $storageId, branchId: $branchId) {
    id
    name
  }
}
    `;
export type DeleteStorageMutationFn = Apollo.MutationFunction<DeleteStorageMutation, DeleteStorageMutationVariables>;

/**
 * __useDeleteStorageMutation__
 *
 * To run a mutation, you first call `useDeleteStorageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStorageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStorageMutation, { data, loading, error }] = useDeleteStorageMutation({
 *   variables: {
 *      storageId: // value for 'storageId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useDeleteStorageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStorageMutation, DeleteStorageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStorageMutation, DeleteStorageMutationVariables>(DeleteStorageDocument, options);
      }
export type DeleteStorageMutationHookResult = ReturnType<typeof useDeleteStorageMutation>;
export type DeleteStorageMutationResult = Apollo.MutationResult<DeleteStorageMutation>;
export type DeleteStorageMutationOptions = Apollo.BaseMutationOptions<DeleteStorageMutation, DeleteStorageMutationVariables>;
export const RestoreStorageDocument = gql`
    mutation RestoreStorage($storageId: Int!, $input: StorageInput!, $branchId: Int!) {
  restoreStorage(storageId: $storageId, input: $input, branchId: $branchId) {
    id
    name
  }
}
    `;
export type RestoreStorageMutationFn = Apollo.MutationFunction<RestoreStorageMutation, RestoreStorageMutationVariables>;

/**
 * __useRestoreStorageMutation__
 *
 * To run a mutation, you first call `useRestoreStorageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreStorageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreStorageMutation, { data, loading, error }] = useRestoreStorageMutation({
 *   variables: {
 *      storageId: // value for 'storageId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useRestoreStorageMutation(baseOptions?: Apollo.MutationHookOptions<RestoreStorageMutation, RestoreStorageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreStorageMutation, RestoreStorageMutationVariables>(RestoreStorageDocument, options);
      }
export type RestoreStorageMutationHookResult = ReturnType<typeof useRestoreStorageMutation>;
export type RestoreStorageMutationResult = Apollo.MutationResult<RestoreStorageMutation>;
export type RestoreStorageMutationOptions = Apollo.BaseMutationOptions<RestoreStorageMutation, RestoreStorageMutationVariables>;
export const GetWarehousesOperationsDocument = gql`
    query GetWarehousesOperations($currentBranchId: Int, $companyId: Int!, $page: Int, $itemsPerPage: Int, $startDate: String, $endDate: String, $action: String, $supplier: Int, $storageId: Int, $productName: String, $productCategory: Int, $edited: Boolean, $remnants: Int) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      branchesPaginated(id: $currentBranchId) {
        branches {
          id
          storageProductRelationHistoryPaginated(
            page: $page
            itemsPerPage: $itemsPerPage
            startDate: $startDate
            endDate: $endDate
            action: $action
            supplier: $supplier
            storageId: $storageId
            productName: $productName
            productCategory: $productCategory
            edited: $edited
            remnants: $remnants
          ) {
            entities {
              id
              date
              action
              operationNumber
              employee {
                id
              }
              historyCreator {
                id
              }
              storage {
                id
                name
                deleted
                type {
                  id
                }
              }
              relationStorage {
                id
                name
                deleted
                type {
                  id
                }
              }
              booking {
                uuid
                id
                date
                time
              }
              writeOffReason {
                name
                id
              }
              remnants
              remnantsForRender
              price
              discount
              amount
              product {
                id
                name
                brand
                sku
                barcode
                productCategoryNew {
                  id
                  name
                }
                unit {
                  id
                  name
                  unitOrder
                }
                units {
                  id
                  name
                }
                unitGroup {
                  id
                  name
                  units {
                    id
                    name
                  }
                }
                alternativeUnit {
                  id
                  name
                  unitGroup {
                    id
                    name
                    units {
                      id
                      name
                    }
                  }
                }
                alternativeValue
              }
              supplier {
                id
                name
              }
              quantityForRender
              quantity
              unit {
                id
                name
              }
              mainQuantity
              mainUnit {
                id
                name
              }
              operationQuantity
              operationUnit {
                id
                name
              }
              comment
              operationNumberReadable
              booking {
                uuid
              }
              historyAction
              isPaid
              paymentType
              client {
                id
                name
                surname
                email
                phone
              }
              relatedSaleHistories {
                id
                price
                discount
                amount
                comment
                isPaid
                paymentType
                operationQuantity
                operationUnit {
                  id
                  name
                }
                employee {
                  id
                }
                client {
                  name
                  phone
                  email
                }
                product {
                  id
                  name
                  brand
                  sku
                }
                storage {
                  id
                  name
                  type {
                    id
                    name
                  }
                }
              }
            }
            totalCount
            currentPage
            itemsPerPage
            pageCount
          }
        }
      }
    }
  }
  relations {
    writeOffReasons {
      id
      name
    }
  }
}
    `;

/**
 * __useGetWarehousesOperationsQuery__
 *
 * To run a query within a React component, call `useGetWarehousesOperationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarehousesOperationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarehousesOperationsQuery({
 *   variables: {
 *      currentBranchId: // value for 'currentBranchId'
 *      companyId: // value for 'companyId'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      action: // value for 'action'
 *      supplier: // value for 'supplier'
 *      storageId: // value for 'storageId'
 *      productName: // value for 'productName'
 *      productCategory: // value for 'productCategory'
 *      edited: // value for 'edited'
 *      remnants: // value for 'remnants'
 *   },
 * });
 */
export function useGetWarehousesOperationsQuery(baseOptions: Apollo.QueryHookOptions<GetWarehousesOperationsQuery, GetWarehousesOperationsQueryVariables> & ({ variables: GetWarehousesOperationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarehousesOperationsQuery, GetWarehousesOperationsQueryVariables>(GetWarehousesOperationsDocument, options);
      }
export function useGetWarehousesOperationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarehousesOperationsQuery, GetWarehousesOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarehousesOperationsQuery, GetWarehousesOperationsQueryVariables>(GetWarehousesOperationsDocument, options);
        }
export function useGetWarehousesOperationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarehousesOperationsQuery, GetWarehousesOperationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWarehousesOperationsQuery, GetWarehousesOperationsQueryVariables>(GetWarehousesOperationsDocument, options);
        }
export type GetWarehousesOperationsQueryHookResult = ReturnType<typeof useGetWarehousesOperationsQuery>;
export type GetWarehousesOperationsLazyQueryHookResult = ReturnType<typeof useGetWarehousesOperationsLazyQuery>;
export type GetWarehousesOperationsSuspenseQueryHookResult = ReturnType<typeof useGetWarehousesOperationsSuspenseQuery>;
export type GetWarehousesOperationsQueryResult = Apollo.QueryResult<GetWarehousesOperationsQuery, GetWarehousesOperationsQueryVariables>;
export const GetAllWarehousesDocument = gql`
    query getAllWarehouses($companyId: Int!, $currentBranchId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branchesPaginated(id: $currentBranchId) {
        branches {
          storages {
            id
            name
            deleted
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllWarehousesQuery__
 *
 * To run a query within a React component, call `useGetAllWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllWarehousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllWarehousesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      currentBranchId: // value for 'currentBranchId'
 *   },
 * });
 */
export function useGetAllWarehousesQuery(baseOptions: Apollo.QueryHookOptions<GetAllWarehousesQuery, GetAllWarehousesQueryVariables> & ({ variables: GetAllWarehousesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllWarehousesQuery, GetAllWarehousesQueryVariables>(GetAllWarehousesDocument, options);
      }
export function useGetAllWarehousesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllWarehousesQuery, GetAllWarehousesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllWarehousesQuery, GetAllWarehousesQueryVariables>(GetAllWarehousesDocument, options);
        }
export function useGetAllWarehousesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllWarehousesQuery, GetAllWarehousesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllWarehousesQuery, GetAllWarehousesQueryVariables>(GetAllWarehousesDocument, options);
        }
export type GetAllWarehousesQueryHookResult = ReturnType<typeof useGetAllWarehousesQuery>;
export type GetAllWarehousesLazyQueryHookResult = ReturnType<typeof useGetAllWarehousesLazyQuery>;
export type GetAllWarehousesSuspenseQueryHookResult = ReturnType<typeof useGetAllWarehousesSuspenseQuery>;
export type GetAllWarehousesQueryResult = Apollo.QueryResult<GetAllWarehousesQuery, GetAllWarehousesQueryVariables>;
export const GetSuppliersDocument = gql`
    query getSuppliers($companyId: Int!, $branchId: Int!) {
  suppliers(companyId: $companyId, branchId: $branchId) {
    id
    name
  }
}
    `;

/**
 * __useGetSuppliersQuery__
 *
 * To run a query within a React component, call `useGetSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuppliersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGetSuppliersQuery(baseOptions: Apollo.QueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables> & ({ variables: GetSuppliersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, options);
      }
export function useGetSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, options);
        }
export function useGetSuppliersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSuppliersQuery, GetSuppliersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSuppliersQuery, GetSuppliersQueryVariables>(GetSuppliersDocument, options);
        }
export type GetSuppliersQueryHookResult = ReturnType<typeof useGetSuppliersQuery>;
export type GetSuppliersLazyQueryHookResult = ReturnType<typeof useGetSuppliersLazyQuery>;
export type GetSuppliersSuspenseQueryHookResult = ReturnType<typeof useGetSuppliersSuspenseQuery>;
export type GetSuppliersQueryResult = Apollo.QueryResult<GetSuppliersQuery, GetSuppliersQueryVariables>;
export type GetWarehousesQueryVariables = Types.Exact<{
  page: Types.Scalars['Int']['input'];
  itemsPerPage: Types.Scalars['Int']['input'];
  currentBranchId: Types.Scalars['Int']['input'];
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetWarehousesQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branchesPaginated?: { __typename?: 'BranchPaginated', branches?: Array<{ __typename?: 'BranchProxy', storagesPaginated?: { __typename?: 'StoragePaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, storages?: Array<{ __typename?: 'StorageProxy', id: number, name: string, description?: string | null, deleted: boolean, default: boolean, type?: { __typename?: 'StorageTypeProxy', id: number, name: string } | null, storageProductRelations?: Array<{ __typename?: 'StorageProductRelationProxy', id?: number | null, quantity?: any | null }> | null }> | null } | null }> | null } | null } | null } | null };

export type GetStorageTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetStorageTypesQuery = { __typename?: 'Query', relations: { __typename?: 'RelationProxy', storageTypes?: Array<{ __typename?: 'StorageTypeProxy', id: number, name: string }> | null } };

export type CreateStorageMutationVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  input: Types.StorageInput;
}>;


export type CreateStorageMutation = { __typename?: 'Mutation', createStorage: { __typename?: 'StorageProxy', id: number, name: string } };

export type UpdateStorageMutationVariables = Types.Exact<{
  storageId: Types.Scalars['Int']['input'];
  input: Types.StorageInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type UpdateStorageMutation = { __typename?: 'Mutation', updateStorage: { __typename?: 'StorageProxy', id: number, name: string } };

export type DeleteStorageMutationVariables = Types.Exact<{
  storageId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type DeleteStorageMutation = { __typename?: 'Mutation', deleteStorage: { __typename?: 'StorageProxy', id: number, name: string } };

export type RestoreStorageMutationVariables = Types.Exact<{
  storageId: Types.Scalars['Int']['input'];
  input: Types.StorageInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type RestoreStorageMutation = { __typename?: 'Mutation', restoreStorage: { __typename?: 'StorageProxy', id: number, name: string } };

export type GetWarehousesOperationsQueryVariables = Types.Exact<{
  currentBranchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  startDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
  endDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
  action?: Types.InputMaybe<Types.Scalars['String']['input']>;
  supplier?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  storageId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  productName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  productCategory?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  edited?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  remnants?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetWarehousesOperationsQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', branchesPaginated?: { __typename?: 'BranchPaginated', branches?: Array<{ __typename?: 'BranchProxy', id: number, storageProductRelationHistoryPaginated?: { __typename?: 'StorageProductRelationHistoryPaginatedType', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, entities?: Array<{ __typename?: 'StorageProductRelationHistoryProxy', id: number, date?: string | null, action?: Types.StorageProductRelationHistoryAction | null, operationNumber?: any | null, remnants?: any | null, remnantsForRender?: string | null, price: string, discount?: number | null, amount?: string | null, quantityForRender?: string | null, quantity?: any | null, mainQuantity?: number | null, operationQuantity?: number | null, comment?: string | null, operationNumberReadable?: string | null, historyAction?: Types.StorageProductRelationHistoryAction | null, isPaid?: boolean | null, paymentType?: string | null, employee?: { __typename?: 'EmployeeProxy', id: number } | null, historyCreator?: { __typename?: 'EmployeeProxy', id: number } | null, storage?: { __typename?: 'StorageProxy', id: number, name: string, deleted: boolean, type?: { __typename?: 'StorageTypeProxy', id: number } | null } | null, relationStorage?: { __typename?: 'StorageProxy', id: number, name: string, deleted: boolean, type?: { __typename?: 'StorageTypeProxy', id: number } | null } | null, booking?: { __typename?: 'BookingMainProxy', uuid: any, id: number, date?: string | null, time?: string | null } | null, writeOffReason?: { __typename?: 'WriteOffReasonProxy', name: string, id: number } | null, product?: { __typename?: 'ProductProxy', id: number, name: string, brand?: string | null, sku?: string | null, barcode?: string | null, alternativeValue?: number | null, productCategoryNew?: { __typename?: 'ProductCategoryNewProxy', id: number, name: string } | null, unit?: { __typename?: 'UnitProxy', id: number, name: string, unitOrder?: number | null } | null, units?: Array<{ __typename?: 'UnitProxy', id: number, name: string }> | null, unitGroup?: { __typename?: 'UnitGroupProxy', id: number, name: string, units?: Array<{ __typename?: 'UnitProxy', id: number, name: string }> | null } | null, alternativeUnit?: { __typename?: 'UnitProxy', id: number, name: string, unitGroup?: { __typename?: 'UnitGroupProxy', id: number, name: string, units?: Array<{ __typename?: 'UnitProxy', id: number, name: string }> | null } | null } | null } | null, supplier?: { __typename?: 'SupplierProxy', id: number, name: string } | null, unit?: { __typename?: 'UnitProxy', id: number, name: string } | null, mainUnit?: { __typename?: 'UnitProxy', id: number, name: string } | null, operationUnit?: { __typename?: 'UnitProxy', id: number, name: string } | null, client?: { __typename?: 'ClientProxy', id: number, name?: string | null, surname?: string | null, email?: string | null, phone?: string | null } | null, relatedSaleHistories?: Array<{ __typename?: 'StorageProductRelationHistoryProxy', id: number, price: string, discount?: number | null, amount?: string | null, comment?: string | null, isPaid?: boolean | null, paymentType?: string | null, operationQuantity?: number | null, operationUnit?: { __typename?: 'UnitProxy', id: number, name: string } | null, employee?: { __typename?: 'EmployeeProxy', id: number } | null, client?: { __typename?: 'ClientProxy', name?: string | null, phone?: string | null, email?: string | null } | null, product?: { __typename?: 'ProductProxy', id: number, name: string, brand?: string | null, sku?: string | null } | null, storage?: { __typename?: 'StorageProxy', id: number, name: string, type?: { __typename?: 'StorageTypeProxy', id: number, name: string } | null } | null }> | null }> | null } | null }> | null } | null } | null } | null, relations: { __typename?: 'RelationProxy', writeOffReasons?: Array<{ __typename?: 'WriteOffReasonProxy', id: number, name: string }> | null } };

export type GetAllWarehousesQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  currentBranchId: Types.Scalars['Int']['input'];
}>;


export type GetAllWarehousesQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branchesPaginated?: { __typename?: 'BranchPaginated', branches?: Array<{ __typename?: 'BranchProxy', storages?: Array<{ __typename?: 'StorageProxy', id: number, name: string, deleted: boolean }> | null }> | null } | null } | null } | null };

export type GetSuppliersQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type GetSuppliersQuery = { __typename?: 'Query', suppliers: Array<{ __typename?: 'SupplierProxy', id: number, name: string } | null> };
